// src/api/recheck.js
//
// The re-check routes (admin-api/routes/feature-recheck.mjs). Each call returns
// { ok, status, body } and never throws on an HTTP refusal: the page renders
// each refusal (403, 409, 422, 503 before migration 141, and before 142 for a
// confirm carrying a corrected position) as its own state.

import { fetchWithAuth } from "./fetchWithAuth";

const BASE = "/api/v1/features/recheck";

async function call(url, options) {
  const res = await fetchWithAuth(url, options);
  let body = null;
  if (res.status !== 204) {
    try { body = await res.json(); } catch { body = null; }
  }
  return { ok: res.ok, status: res.status, body };
}

// Review's parameter: an operating AOI keeps the items inside it. Absent, every
// item, and the request is as it was before the filter.
const aoiParam = (aoi) => (aoi ? `operating_aoi_id=${encodeURIComponent(aoi)}` : "");
const withAoi = (url, aoi) => (aoi ? `${url}${url.includes("?") ? "&" : "?"}${aoiParam(aoi)}` : url);

const json = (method, payload) => ({
  method, headers: { "content-type": "application/json" }, body: JSON.stringify(payload),
});

export const recheckApi = {
  operatingAois: () => call(`${BASE}/operating-aois`),
  stats: (aoi) => call(withAoi(`${BASE}/stats`, aoi)),
  cells: (aoi) => call(withAoi(`${BASE}/cells`, aoi)),
  queue: (x, y, aoi) => call(withAoi(`${BASE}/queue?cell_x=${x}&cell_y=${y}&limit=500`, aoi)),
  item: (id) => call(`${BASE}/items/${encodeURIComponent(id)}`),
  lock: (x, y) => call(`${BASE}/cells/${x}/${y}/lock`, { method: "POST" }),
  release: (x, y) => call(`${BASE}/cells/${x}/${y}/lock`, { method: "DELETE" }),
  verdict: (v) => call(`${BASE}/verdicts`, json("POST", v)),
};
